'use client';

import React, {useEffect, useState, useRef, Suspense} from "react";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";

import {DeleteData, GetData, PostData} from "@/apis";
import ContentTitle from "./ContentTitle";
import InputBox from "./form/InputBox";
import TextBox from "./form/TextBox";
import PrivacyCheckWrap from "./PrivacyCheckWrap";
import WhiteButton from "./button/WhiteButton";
import { CompanyInfoObj, MOBILE_WIDTH, TABLET_WIDTH } from "@/constants";
import InputFile from "./form/InputFile";

import { makePhoneFormatExtension } from "@/utils";
import { loadCaptchaEnginge, validateCaptcha } from "react-simple-captcha";
import AlertModal from "./AlertModal";
import PrivacyInfoModal from "./PrivacyInfoModal";
import Captcha from "./Captcha";
import { useRouter } from "next/navigation";
import { useSearchParams } from 'next/navigation';

const WRAPPER_MARGIN        = '11.4%';
const WRAPPER_MARGIN_TABLET = '7%';



const SubscribePage = ({ gtag }) => {
    const searchParams = useSearchParams();
    const router = useRouter();
    const isCancel = searchParams.has('cancel');
    // Captcha
    const [ captcha, setCaptcha ] = useState('');
    const handleCaptcha           = (e) => {
        setCaptcha(e.target.value);
    }
    // gtm
    // function gtag_report_conversion(url) {
    //     const callback = function () {
    //         if (typeof (url) != 'undefined') {
    //             window.location = url;
    //         }
    //     };
    //     gtag('event', 'conversion', {
    //         'send_to': 'AW-11303882783/7DcmCKXcz9MYEJ-gjo4q', 'event_callback': callback
    //     });
    //     return false;
    // }

    const [ privacyModalShow, setPrivacyModalShow ] = useState(false);
    const [ alertModalShow, setAlertModalShow ]     = useState(false);
    const [ alertModalShowType, setAlertModalShowType ]     = useState(null);
    const closeModal                                = () => {
        if (privacyModalShow) setPrivacyModalShow(false);
        if (alertModalShow) setAlertModalShow(false);
        if(alertModalShowType) setAlertModalShowType(null);
    }
    const confirmModal = () => {
        if (privacyModalShow) setPrivacyModalShow(false);
        if (alertModalShow) setAlertModalShow(false);
        if(alertModalShowType) setAlertModalShowType(null);
        router.push("/")
    }

    const selectedBudget = [
        '5백만 원 미만',
        '5백~1천만 원',
        '1천~3천만 원',
        '3천~5천만 원',
        '5천만 원 이상',
        '미정'
    ];

    const mutation = isCancel
        ? DeleteData("letterSubscribe", {
            onSuccess: () => {
                setAlertModalShow(true);
                setSubscribeData(subscribeDataInit);
                setCaptcha('');
                setInitFIle(true);
                validateCaptcha('');
                setIsSomethingChanged(false);
            },
            onError: (e) => {
                // console.log("delete error", e);
                alert('구독취소에 실패앴습니다. 관리자에게 문의 주세요.');
                router.push("/")
            },
        })
        : PostData("letterSubscribe", {
            onSuccess: () => {
                console.log("post success");
                setAlertModalShow(true);
                setSubscribeData(subscribeDataInit);
                setCaptcha('');
                setInitFIle(true);
                validateCaptcha('');
                setIsSomethingChanged(false);
            },
            onError: (e) => {
                console.log("post error");
                if(e.response && e.response.data === "이미 구독중인 이메일입니다.") {
                    alert(e.response.data)
                }
            },
        });

    const { trigger } = mutation;
    const subscribeDataInit = {
        name: '',
        email: '',
    }
//setSubscribeData setSubscribeDataValid
    const [ subscribeData, setSubscribeData ]               = useState(subscribeDataInit);
    const [ subscribeDataValid, setSubscribeDataValid ]     = useState(false);
    const [ isSomethingChanged, setIsSomethingChanged ] = useState(false);
    const [ initFile, setInitFIle ]                     = useState(false);

    const handleInputData = (key, value) => {
        subscribeData[key] = value
        setSubscribeData({ ...subscribeData })
        if (value) {
            setIsSomethingChanged(true);
        }
    }

    useEffect(() => {
        handleApplyData()
    }, [ subscribeData, captcha ]);

    const handleApplyData = () => {
        if (
            subscribeData.name !== '' &&
            subscribeData.email !== '' &&
            subscribeData.agree &&
            captcha !== '') {
            setSubscribeDataValid(true);
        } else {
            setSubscribeDataValid(false);
        }
    }

    const nameInput       = useRef(null);
    const emailInput       = useRef(null);

    const handleSendData = (type = undefined) => {
        if(type === "cancel"){
            setAlertModalShowType(type);
            setAlertModalShow(true);
            return false;
        }
        if (subscribeData.name === '') {
            //
            alert(`${!isCancel ? "신청" : "취소"}자분 성함 입력해 주세요.`);
            nameInput.current.focus();
            return false;
        }

        if (subscribeData.email === '') {
            alert('이메일을 입력해 주세요.');
            emailInput.current.focus();
            return false;
        }

        const regexEmail = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,}$/;
        if (subscribeData.email && !regexEmail.test(subscribeData.email)) {
            alert('올바른 형식의 이메일 주소를 입력해 주세요.');
            emailInput.current.focus();
            return false;
        }

        if (!subscribeData.agree) {
            alert('개인정보처리방침에 동의해 주세요.');
            return false;
        }

        if (!validateCaptcha(captcha)) {
            alert('자동입력방지 문자가 일치하지 않습니다. 다시 입력해 주세요.');
            loadCaptchaEnginge(4);
            setCaptcha('');
            return false;
        }

        const formData = new FormData();
        let arg;
        if(isCancel){
            const deletePayload = {
                name: subscribeData.name,
                email: subscribeData.email,
            };

            arg = {
                data: deletePayload,
                config: {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            };
        } else{
            for (let key in subscribeData) {
                if (key === 'agree') continue;
                formData.append(key, subscribeData[key]);
            }
            arg = {
                data: formData, config: {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            }
        }


        if (subscribeDataValid)  {
            trigger(arg);
            // gtag_report_conversion();
        }

    }

    useEffect(() => {
        const msg =
            '작성 중인 내용이 있습니다. 페이지를 벗어나면 저장되지 않습니다.';
        const handleWnd = (e) => {
            if (!isSomethingChanged) return;
            e.preventDefault();
            e.returnValue = msg;
        };
        const handleRoute = () => {
            if (isSomethingChanged && !confirm(msg)) throw 'Abort route change';
        };

        window.addEventListener('beforeunload', handleWnd);
        // App Router에선 `window.addEventListener('popstate')` 로 대체
        window.addEventListener('popstate', handleRoute);

        return () => {
            window.removeEventListener('beforeunload', handleWnd);
            window.removeEventListener('popstate', handleRoute);
        };
    }, [isSomethingChanged]);


    const isMobile = useMediaQuery({ query: `(max-width: ${ MOBILE_WIDTH }px)` });

    return (
        <>
            <SubscribeCont>
                <div className="subscribe_title">
                    <div>
                        <ContentTitle
                            subtitle="Subscribe to Newsletter"
                        >
                            <b>
                                뉴스레터 구독{!isCancel ? "신청" : "취소"}
                            </b>
                        </ContentTitle>
                        <p className="subtext">
                            신청서를 제출해 주시면<br/>
                            <b>뉴스레터 메일링 서비스</b>가 {!isCancel ? "시작" : "종료"}됩니다.
                        </p>
                    </div>
                    <div className="contact_info">
                        <div className="address">
                            <span>오시는 길</span>
                            <p>
                                { CompanyInfoObj.address }
                                <a href="https://naver.me/5fIpYPIJ" target="_blank" rel="noreferrer">
                                    지도 보기
                                    <img src="/img/arr_upright.svg" alt="오른쪽 위를 가리키는 화살표"/>
                                </a>
                            </p>
                        </div>
                        <div className="call">
                            <p>Tel. { CompanyInfoObj.tel }</p>
                            <p>Email. { CompanyInfoObj.email }</p>
                        </div>
                    </div>
                </div>

                <div className="subscribe_container">
                    <p className="require_text">
                        <i className="require">*</i>&nbsp;필수 작성 항목
                    </p>
                    <div className="subscribe_wrapper introduce_wrapper">
                        <h3>
                            안녕하세요, <b>{!isCancel ? "신청" : "취소"}하시는 분의 정보</b>를 알려주세요.
                        </h3>
                        <div className="introduce_input_list">
                            <div className="input_wrap">
                                <h4>{!isCancel ? "신청" : "취소"}자 성함&nbsp;<i className="require">*</i></h4>
                                <InputBox
                                    value={subscribeData.name}
                                    ref={nameInput}
                                    onChange={(e) => handleInputData("name", e.target.value)}
                                />
                            </div>
                            <div className="input_wrap">
                                <h4>이메일&nbsp;<i className="require">*</i></h4>
                                <InputBox
                                    value={subscribeData.email}
                                    ref={emailInput}
                                    onChange={(e) => handleInputData("email", e.target.value)}
                                />
                            </div>
                        </div>
                    </div>


                    <PrivacyCheckWrap
                        checked={subscribeData.agree}
                        onClickCheck={(e) => handleInputData("agree", e.target.checked)}
                        onClickMore={() => setPrivacyModalShow(!privacyModalShow)}
                    />
                    <Captcha
                        className="captcha_wrapper"
                        captcha={captcha}
                        handleCaptcha={handleCaptcha}
                    />

                    <div className={`send_button_wrap ${isCancel ? "between" : ""}`}>
                        {
                            !isCancel ?

                                <WhiteButton
                                    type="button"
                                    className="apply_send_button on"
                                    onClick={handleSendData}
                                >
                                    Send
                                </WhiteButton>
                                :
                                <>
                                    <WhiteButton
                                        type="button"
                                        className="apply_send_button on"
                                        onClick={handleSendData}
                                    >
                                        Yes
                                    </WhiteButton>
                                    <WhiteButton
                                        type="button"
                                        className="apply_send_button on"
                                        onClick={()=>{
                                            handleSendData("cancel")
                                        }}
                                    >
                                        No
                                    </WhiteButton>
                                </>
                        }
                    </div>

                </div>
            </SubscribeCont>
            {privacyModalShow ? (<PrivacyInfoModal
                closeModal={closeModal}
            ></PrivacyInfoModal>) : (<></>)}
            {alertModalShow ? (<AlertModal
                closeModal={closeModal}
                confirmModal={confirmModal}
            >
                <p>
                    {
                        !isCancel ?
                            "구독신청이 완료되었습니다."
                            :
                            alertModalShowType === "cancel" ?
                                "구독신청 상태가 유지되었습니다."
                                :
                                "구독취소가 완료되었습니다."
                    }

                </p>
            </AlertModal>) : (<></>)}
        </>);
}
const SubscribeCont = styled.section`
    display: flex;
  align-items: flex-start;
  padding: 0 4.2%;

  .subscribe_title {
    position: sticky;
    top: var(--header);
    left: 0;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100vh - var(--header));
    padding: 4.2% 0;

    .subtext {
      margin-top: 4.8rem;
      font-size: 1.8rem;
      font-weight: 300;
      line-height: 1.7;
    }

    .contact_info {
        opacity: 0;
        visibility: hidden;
      .address {
        margin-bottom: 2rem;

        span {
          font-size: 1.8rem;
          font-weight: var(--fw_medium);
        }

        p {
          margin-top: 1.2rem;
          font-size: 2.4rem;
          font-weight: var(--fw_sbold);

          a {
            display: inline-flex;
            align-items: center;
            margin-left: 2rem;
            padding: 1.4rem 2.8rem 1.3rem 3.2rem;
            font-size: 1.5rem;
            font-weight: var(--fw_medium);
            border: 1px solid var(--gray1);
            border-radius: 50%;
            transition: var(--trans_time);
            
            img {
              width: 2.4rem;
              margin-left: 0.8rem;
              transition: var(--trans_time);
            }

            &:hover {
              color: var(--black1);
              background: var(--main1);

              img {
                filter: invert(0.85);
              }
            }
          }
        }
      }

      .call {
        display: flex;
        align-items: center;

        p {
          margin-right: 3.2rem;
          font-size: 2rem;
          font-weight: var(--fw_medium);

          &:last-child {
            margin-right: 0;
          }
        }
      }

        @media screen and (max-width: ${MOBILE_WIDTH}px) {
            display: none;
        }
        
        
        
        
        
        
        
    }
  }

  .subscribe_container {
    position: relative;
    flex: 1 1 100%;
    height: 100%;
    margin-top: 4.2%;
    padding: 0 0 8.8% 13.3%;
  }
  
  .require_text {
    position: absolute;
    top: 2px;
    right: 0;
    font-size: 1.8rem;
    font-weight: var(--fw_medium);
    line-height: 1.7;
  }

  .subscribe_wrapper {
    margin-bottom: ${ WRAPPER_MARGIN };

    h3 {
      margin-bottom: 4rem;
      font-size: 2.4rem;
      font-weight: var(--fw_thin);
      line-height: 1.7;

      &.smargin {
        margin-bottom: 0.4rem;
      }

      br {
        display: none;
      }

      span {
        display: block;
        margin-top: 0.4rem;
        font-size: 1.6rem;
        color: var(--gray5);
      }
    }

    &.introduce_wrapper {
      .introduce_input_list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        > * {
          flex: 0 1 auto;
          width: calc(50% - 1rem);

          &:nth-child(2n) {
            margin-left: 2rem;
          }

          &:last-child {
            margin-bottom: 0;
          }

          h4 {
            margin-bottom: 0.8rem;
            font-size: 2rem;
            font-weight: var(--fw_medium);
            line-height: 1.7;
          }

          input {
            width: 100%;
          }
        }

        .input_wrap_full {
          width: 100%;
        }
      }
    }

    .check_input_list {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      position: relative;
      width: calc(100% + 2rem);
      transform: translateX(-1rem);

      > * {
        flex: 0 1 auto;
        width: calc(33.33% - 2rem);
        margin: 0 1rem 1.6rem;

        &:nth-last-child(-n+3) {
          margin-bottom: 0;
        }
      }
    }
  }

  .privacy_checkbox_input {
    label {
      padding-left: 12px;
    }
  }

  .captcha_wrapper {
    margin-top: ${ WRAPPER_MARGIN };
  }

  .send_button_wrap {
    margin-top: ${ WRAPPER_MARGIN };
    text-align: center;
      &.between{
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 20px;
      }
  }

  @media screen and (max-width: 1600px) {
    .subscribe_container {
      padding-left: 8%;
    }
  }

  @media screen and (max-width: 1366px) {
    padding: 0 3.4%;

    .subscribe_container {
      padding-left: 7.4%;
    }
  }

  @media screen and (max-width: 1280px) {
    padding: 0 3%;

    .subscribe_container {
      padding-left: 6%;
    }

    .subscribe_wrapper {
      &.introduce_wrapper {
        .introduce_input_list {
          & > * {
            &:nth-child(2n) {
              margin-left: 1.2rem;
            }
          }
        }
      }

      .check_input_list {
        & > * {
          margin: 0 0.6rem 1rem;
        }
      }
    }
  }

  @media screen and (max-width: ${ TABLET_WIDTH }px) {
    display: block;

    .subscribe_title {
      position: static;
      display: block;
      height: auto;
      padding: 30px 0 40px;
      border-bottom: 1px dashed var(--gray2);

      .subtext {
        margin-top: 40px;
      }

      .contact_info {
        margin-top: 43px;

        .address {
          margin-bottom: 0;

          p {
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            a {
              margin: 15px 0 0;
              border-color: var(--main1);
            }
          }
        }

        .call {
          display: none;
        }
      }
    }

    .subscribe_container {
      padding-left: 0;
    }

    .require_text {
      display: none;
    }

    .subscribe_wrapper {
      margin-bottom: ${ WRAPPER_MARGIN_TABLET };

      h3 {
        br {
          display: block;
        }
      }

      .check_input_list {
        > * {
          width: calc(33.3% - 1.4rem);
        }
      }
    }

    .captcha_wrapper {
      margin-top: ${ WRAPPER_MARGIN_TABLET };
    }

    .send_button_wrap {
      margin-top: ${ WRAPPER_MARGIN_TABLET };
    }
  }

  @media screen and (max-width: ${ MOBILE_WIDTH }px) {
    padding: 0 24px 207px 24px;

    .subscribe_title {
      margin-bottom: 40px;

      .subtext {
        font-size: 14px;
      }

      .contact_info {
        .address {
          span {
            font-size: 16px;
            font-weight: var(--fw_base);
          }

          p {
            margin-top: 15px;
            font-size: 18px;

            a {
              padding: 12px 18px 12px 24px;

              &:hover {
                background: transparent;
                color: var(--white1);

                img {
                  filter: none;
                }
              }

              img {
                margin-left: 5px;
              }
            }
          }
        }
      }
    }

    .subscribe_container {
      padding-bottom: 0;
    }

    .subscribe_wrapper {
      margin-bottom: 60px;

      h3 {
        margin-bottom: 32px;
        font-size: 14px;

        span {
          margin-top: 0;
          margin-bottom: -16px;
          font-size: 12px;
          font-weight: var(--fw_medium);
        }
      }

      .check_input_list {
        width: calc(100% + 16px);
        transform: translateX(-8px);

        > * {
          flex: 0 1 auto;
          width: calc(50% - 8px);
          margin: 0 4px 8px;

          &:nth-last-child(-n+4) {
            margin-bottom: 8px;
          }

          &:nth-last-child(-n+2) {
            margin-bottom: 0;
          }
        }
      }

      &.introduce_wrapper {
        .introduce_input_list {
          display: block;

          > * {
            width: 100%;
            margin-bottom: 32px;

            &:nth-child(2n) {
              margin-left: 0;
            }

            &:last-child {
              margin-bottom: 0;
            }

            h4 {
              margin-bottom: 6px;
              font-size: 14px;
            }
          }
        }
      }
    }

    .captcha_wrapper {
      margin-top: 60px;
    }

    .send_button_wrap {
      margin-top: 80px;
    }
  }
`;

const StyledCheckRadioBox = styled(InputBox)`
  input {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 0 !important;
    height: 0 !important;
    min-width: initial !important;
    min-height: initial !important;
    overflow: hidden !important;
    opacity: 0 !important;
    font-size: 0 !important;
    line-height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    border: none !important;

    & + label {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 6.8rem;
      padding: 0;
      font-size: 1.8rem;
      font-weight: var(--fw_medium);
      color: var(--gray2);
      letter-spacing: -0.01em;
      text-align: center;
      border: 1px solid var(--gray1);
      transition: background 0.1s;

      &:hover {
        background: #393939;
        border-color: #393939;
      }

      &[isImg] {
        display: flex;
        flex-direction: column;
        height: 16rem;

        img {
          width: 4.8rem;
          margin-bottom: 1.2rem;
        }
      }
    }

    &:checked + label {
      border-color: var(--white1);
      font-weight: var(--fw_medium);
      color: var(--white1);

      &[isImg] img {
        filter: invert(0%) sepia(20%) saturate(439%) hue-rotate(193deg) brightness(113%) contrast(104%);
      }
    }
  }

  @media screen and (max-width: ${ MOBILE_WIDTH }px) {
    input {
      &[type="radio"] + label {
        font-size: 13px;
      }

      & + label {
        height: 44px;
        font-size: 14px;
        font-weight: var(--fw_medium);

        &:hover {
          background: transparent;
        }

        &[isImg] {
          display: flex;
          flex-direction: column;
          height: 104px;
  
          img {
            width: 28px;
            margin-bottom: 8px;
          }
        }
      }

      &:not(:checked) + label:hover {
        border-color: var(--gray1);
      }
    }
  }
`;
export default SubscribePage;
